import React, { ReactNode } from "react";
import {
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";

interface IProps {
  oppositeContent: ReactNode;
  oppositeContentStyle: any;
  dotStyle?: any;
  children: ReactNode;
}

const CustomTimeline: React.FC<IProps> = (props) => {
  const { oppositeContent, oppositeContentStyle, dotStyle, children } = props;
  return (
    <TimelineItem
      id="Timeline_item"
      data-test-id="Timeline_item"
      aria-label="Timeline item"
    >
      <TimelineOppositeContent 
        color="textSecondary" 
        sx={oppositeContentStyle}
        id="Timeline_opposite_content"
        data-test-id="Timeline_opposite_content"
        aria-label="Timeline opposite content"
      >
        {oppositeContent}
      </TimelineOppositeContent>
      <TimelineSeparator
        id="Timeline_separator"
        data-test-id="Timeline_separator"
        aria-label="Timeline separator"
      >
        <TimelineConnector 
          id="Timeline_connector_top"
          data-test-id="Timeline_connector_top"
          aria-label="Timeline connector"
        />
        <TimelineDot 
          sx={dotStyle}
          id="Timeline_dot"
          data-test-id="Timeline_dot"
          aria-label="Timeline dot"
        />
        <TimelineConnector 
          id="Timeline_connector_bottom"
          data-test-id="Timeline_connector_bottom"
          aria-label="Timeline connector"
        />
      </TimelineSeparator>
      <TimelineContent
        id="Timeline_content"
        data-test-id="Timeline_content"
        aria-label="Timeline content"
      >
        {children}
      </TimelineContent>
    </TimelineItem>
  );
};

export default CustomTimeline;
